import { Box, Flex, Heading, Text } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';
import { DynamicHoverData } from '~/entities/MyTickets/types/dynamicHover';
import { DetailItem } from './DetailItem';

interface GiftsAndDonationsHoverProps {
  dynamicData: DynamicHoverData;
}

export function GiftsAndDonationsHover({
  dynamicData,
}: GiftsAndDonationsHoverProps) {
  const { t } = useTranslate();

  return (
    <Box
      css={{
        marginTop: '$4',
        width: '100%',
      }}
    >
      <Flex css={{ gap: '$4', width: '100%' }}>
        {dynamicData.boxes.map((box) => (
          <Box
            key={box.title}
            css={{
              flex: 1,
              padding: '$4',
              backgroundColor: '#FFFFFF',
              borderRadius: '8px',
              border: '1px solid #EEEFF2',
            }}
          >
            <Heading css={{ fontSize: '$sm', mb: '$4', fontWeight: '$bold' }}>
              {t(box.title)}
            </Heading>

            {box.title === 'form.myTickets.title.details' ? (
              <Box
                css={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: '$4',
                  width: '100%',
                }}
              >
                {box.fields.map((field) => (
                  <DetailItem key={`${field.label}-${field.value}`} field={field} />
                ))}
              </Box>
            ) : (
              <Box css={{ width: '100%' }}>
                {box.fields.map((field) => (
                  <Text key={`${field.label}-${field.value}`} css={{
                    fontSize: '$sm',
                    lineHeight: '1.5',
                    color: '$gray600'
                  }}>
                    {field.value}
                  </Text>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Flex>
    </Box>
  );
}